var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('add-beneficiary-referent', {
    attrs: {
      "data-to-show": _vm.popupAddState
    },
    on: {
      "showChange": function (val) {
        _vm.changeStateAddBenficiaryReferentPopup(val);
      }
    }
  }), _vm._v(" "), _c('edit-specific-rights', {
    attrs: {
      "data-to-show": _vm.popupEditSpecifyRightState
    },
    on: {
      "showChange": function (val) {
        _vm.changeStateEditSpecifyRightsBenficiaryReferentPopup(val);
      }
    }
  }), _vm._v(" "), _c('delete-beneficiary-referent', {
    attrs: {
      "data-to-show": _vm.popupDeleteState
    },
    on: {
      "showChange": function (val) {
        _vm.changeStateDeletePopup(val);
      }
    }
  }), _vm._v(" "), _vm.$can(_vm.constants.PERMISSION_GESTION_DROITS_REFERENT_DROITS_SUR_NEOPASS) ? _c('h5', {
    staticClass: "text-left ml-5 lg:ml-15 2xl:ml-20 mt-15 text-indigo-600"
  }, [_vm._v("\n    Liste des référents >\n    "), _c('span', {
    staticClass: "text-gray-600"
  }, [_vm._v("Liste des bénéficiaires attribués à\n      " + _vm._s(_vm.referentToEdit.firstname) + "\n      "), _c('span', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s(_vm.referentToEdit.lastname))])])]) : _vm._e(), _vm._v(" "), _vm.$can(_vm.constants.PERMISSION_GESTION_DROITS_REFERENT_DROITS_SUR_NEOPASS) ? _c('div', {}, [_c('div', {
    staticClass: "flex content-center items-center justify-between my-15 2xl:my-20 mx-5 lg:mx-15 2xl:mx-20"
  }, [_c('div', {
    staticClass: "flex flex-col items-center justify-center mt-5 w-full"
  }, [_c('div', {
    staticClass: "flex items-center justify-between w-full px-5 mb-2"
  }, [true || !_vm.referentToEdit.roles.some(function (role) {
    return role.type === 'admin';
  }) ? _c('add-button', {
    attrs: {
      "libelle": "Ajouter un bénéficiaire à gérer",
      "responsive": ""
    },
    on: {
      "add": function ($event) {
        return _vm.displayAddBenficiaryReferentPopup();
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w-2/3 sm:w-1/3"
  }, [_c('search-bar', {
    attrs: {
      "name": "searchBeneficiaryToReferent",
      "libelle": "",
      "value": _vm.searchBeneficiary,
      "placeholder": "Rechercher un bénéficiaire",
      "big": false,
      "inherits": false,
      "has-border": false
    },
    on: {
      "input": function (newValue) {
        _vm.searchBeneficiary = newValue;
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "w-full px-5 flex items-center justify-end"
  }, [_c('sort-button', {
    attrs: {
      "sort": _vm.sort
    },
    on: {
      "sorted": function (sortType) {
        _vm.sort = sortType;
      }
    }
  })], 1)])]), _vm._v(" "), _c('list-grid', {
    attrs: {
      "grid": "grid-cols-6 md:grid-cols-12",
      "list-items": _vm.beneficiariesSort.filter(function (_) {
        return !_vm.saving;
      }),
      "label-key": "beneficiary"
    },
    scopedSlots: _vm._u([_vm.beneficiariesSort.filter(function (_) {
      return !_vm.saving;
    }).length > 0 ? {
      key: "header",
      fn: function () {
        return [_c('div', {
          staticClass: "col-start-1 lg:col-start-2 col-span-2 md:col-span-5 lg:col-span-4 ml-5 md:ml-10 xl:ml-0"
        }, [_vm._v("\n          Bénéficiaires\n        ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-2 md:col-span-3"
        }, [_vm._v("Rôles")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-1 md:col-span-2 truncate"
        }, [_vm._v("\n          Droits d'accès spécifiques\n        ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-1 md:col-span-2 truncate"
        }, [_vm._v("\n          Révoquer les droits\n        ")])];
      },
      proxy: true
    } : null, {
      key: "accordionDescription",
      fn: function (_ref) {
        var item = _ref.item,
          num = _ref.num;
        return [_c('div', {
          staticClass: "col-start-1 col-span-1 hidden lg:inline"
        }, [_c('ProfilePicture', {
          attrs: {
            "size": "max-w-10 w-10 h-10",
            "other-object": item
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "col-start-1 lg:col-start-2 col-span-2 md:col-span-5 lg:col-span-4 ml-5 md:ml-10 xl:ml-0"
        }, [_vm._v("\n          " + _vm._s(item.firstname) + "\n          "), _c('span', {
          staticClass: "uppercase truncate"
        }, [_vm._v(_vm._s(item.lastname))])]), _vm._v(" "), _c('div', {
          staticClass: "col-span-2 md:col-span-3 place-self-center justify-self-start"
        }, [!_vm.referentToEdit.roles.some(function (role) {
          return role.type === 'admin';
        }) ? _c('input-select', {
          attrs: {
            "name": `role${item.id}`,
            "datas": _vm.listRoles,
            "value": item.role,
            "libelle": ""
          },
          on: {
            "input": function (newValue) {
              item.role = newValue;
              _vm.changeBeneficiaryReferentRole(item);
            }
          }
        }) : _c('input-select', {
          attrs: {
            "name": `role${item.id}`,
            "datas": [{
              value: _vm.referentToEdit.roles[0].name
            }],
            "value": _vm.referentToEdit.roles[0].name,
            "libelle": "",
            "disabled": ""
          }
        })], 1), _vm._v(" "), !_vm.referentToEdit.roles.some(function (role) {
          return role.type === 'admin';
        }) ? _c('div', {
          staticClass: "col-span-1 md:col-span-2 place-self-center justify-self-start"
        }, [_c('div', {
          staticClass: "w-max",
          on: {
            "click": function ($event) {
              return _vm.displayEditSpecifyRightsBenficiaryReferentPopup(item);
            }
          }
        }, [item.role === 'Accès spécifiques' ? _c('circle-button', {
          attrs: {
            "icon": "options",
            "bg-color": "bg-indigo-100",
            "bg-color-hover": "hover:bg-indigo-300",
            "border-color": "border-indigo-600",
            "label": "Modifier les droits spécifiques",
            "enable-click": false
          }
        }) : _vm._e()], 1)]) : _c('div', {
          staticClass: "col-span-1 md:col-span-2 place-self-center justify-self-start"
        }), _vm._v(" "), _c('div', {
          staticClass: "col-span-1 md:col-span-2 place-self-center justify-self-start"
        }, [!_vm.referentToEdit.roles.some(function (role) {
          return role.type === 'admin';
        }) ? _c('circle-button', {
          attrs: {
            "icon": "close",
            "icon-scale": "75",
            "label": "Révoquer les droits"
          },
          on: {
            "buttonClick": function ($event) {
              return _vm.displayConfirmDeletePopup(item);
            }
          }
        }) : _vm._e()], 1)];
      }
    }], null, true)
  }), _vm._v(" "), _vm.beneficiariesReferent.length > 0 && _vm.beneficiariesSort.length === 0 ? _c('div', {
    staticClass: "flex flex-col justify-center items-center w-full"
  }, [_c('h3', {
    staticClass: "text-pink-600 w-full text-center font-semibold text-lg mt-12"
  }, [_vm._v("\n        Aucun résultat !\n      ")]), _vm._v(" "), _c('h4', {
    staticClass: "text-indigo-600 w-4/6 text-center text-base mt-8 mb-16"
  }, [_vm._v("\n        Aucun bénéficiaire ne correspond à votre recherche, veuillez réessayer\n        avec de nouveaux éléments\n      ")]), _vm._v(" "), _c('div', [_c('illustration', {
    attrs: {
      "name": "no_result"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _vm.beneficiariesReferent.length == 0 ? _c('div', {
    staticClass: "text-gray-600 text-center w-full"
  }, [_vm._v("\n      " + _vm._s(_vm.referentToEdit.firstname) + "\n      "), _c('span', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s(_vm.referentToEdit.lastname))]), _vm._v(" n'a aucun\n      Neopass attribué\n    ")]) : _vm._e(), _vm._v(" "), _vm.saving ? _c('div', {
    staticClass: "w-full flex justify-center items-center"
  }, [_c('div', {
    staticClass: "border rounded-full h-3 w-3 mr-1 sm:h-4 sm:w-4 sm:mr-1.5 border-t-2 border-r-2 border-l-0 border-b-0 border-gray-900 border-opacity-25 animate-spin"
  })]) : _vm._e()], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }